if (!customElements.get('newsletter-form')) {
  class NewsletterForm extends HTMLElement {
    static formAssociated = true;
    static observedAttributes = ['email', 'message'];

    constructor() {
      super();

      this.elForm = this.querySelector('form');
      this.elInput = this.querySelector('input[type="email"]');
      this.elProperties = this.querySelectorAll('[data-property]');
      this.elMessage = this.querySelector('[data-message]');

      this.email = this.getAttribute('email');
      this.listId = this.getAttribute('list-id');
      this.source = this.getAttribute('source');
      this.hubspotPortalId = this.getAttribute('hubspot-portal-id');
      this.hubspotFormId = this.getAttribute('hubspot-form-id');
      this.hubspotFieldCustomerType = this.getAttribute('hubspot-field-customer-type') || 'contact_type';
      this.hubspotFieldSource = this.getAttribute('hubspot-field-source') || 'signup_source';
      this.url = this.elForm.getAttribute('action');
      this.useHubspot = Boolean(this.hubspotPortalId && this.hubspotFormId);

      this.elForm.addEventListener('submit', this.validate.bind(this));
      this.elInput.addEventListener('input', this.setEmail.bind(this));
      this.elInput.addEventListener('focus', this.reset.bind(this));
      this.elInput.addEventListener('focusout', () => {
        if (!this.email) this.classList.remove('focussed');
      });
    }

    setEmail(ev) {
      this.setAttribute('email', ev.currentTarget.value);
    }

    reset() {
      this.elInput.setAttribute('aria-invalid', false);
      this.classList.remove('error');
      this.classList.add('focussed');
      this.setAttribute('message', '');
    }

    validate(ev) {
      ev.preventDefault();
      const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);

      if (!valid) {
        this.setAttribute('message', 'Invalid Email');
        this.elInput.setAttribute('aria-invalid', true);
        this.classList.remove('error');
        return;
      }

      if (this.useHubspot && this.elProperties.length && !this.getCheckedProperties().length) {
        this.setAttribute('message', 'Please select Homeowner or Trade Professional');
        this.classList.add('error');
        return;
      }

      this.classList.add('submitting');
      this.subscribe()
        .then((response) => {
          this.classList.remove('submitting');

          if (response.ok) {
            this.classList.add('success');
            this.setAttribute('message', 'Thank you for signing up!');
          } else {
            this.classList.add('error');
            this.setAttribute('message', 'Oops! Please try again later');
          }
        })
        .catch(() => {
          this.classList.remove('submitting');
          this.classList.add('error');
          this.setAttribute('message', 'Oops! Please try again later');
        });
    }

    getCheckedProperties() {
      return this.elProperties ? [...this.elProperties].filter((el) => el.checked) : [];
    }

    getHubspotCookie(name) {
      const match = document.cookie.match(new RegExp(`${name}=([^;]+)`));
      return match ? match[1] : null;
    }

    async subscribeHubspot() {
      const fields = [{ name: 'email', value: this.email }];
      const checkedProperties = this.getCheckedProperties();

      checkedProperties.forEach((el) => {
        const propertyName = el.getAttribute('data-property');
        const hubspotFieldName =
          propertyName === 'customer_type' ? this.hubspotFieldCustomerType : propertyName;

        fields.push({
          name: hubspotFieldName,
          value: el.value,
        });
      });

      if (this.source) {
        fields.push({
          name: this.hubspotFieldSource,
          value: this.source,
        });
      }

      const context = {
        pageUri: window.location.href,
        pageName: document.title,
      };

      const hutk = this.getHubspotCookie('hubspotutk');
      if (hutk) context.hutk = hutk;

      const url = `https://api.hsforms.com/submissions/v3/integration/submit/${this.hubspotPortalId}/${this.hubspotFormId}`;

      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          submittedAt: Date.now(),
          fields,
          context,
        }),
      });
    }

    async subscribeKlaviyo() {
      const checkedProperties = this.getCheckedProperties();
      const options = {
        method: 'POST',
        headers: { revision: '2024-05-15', 'content-type': 'application/json' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: this.source,
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: this.email,
                    ...(checkedProperties.length && {
                      properties: Object.assign(
                        {},
                        ...checkedProperties.map((el) => ({
                          [el.getAttribute('data-property')]: el.value,
                        }))
                      ),
                    }),
                  },
                },
              },
            },
            relationships: { list: { data: { type: 'list', id: this.listId } } },
          },
        }),
      };

      return fetch(this.url, options);
    }

    subscribe() {
      if (this.useHubspot) return this.subscribeHubspot();
      return this.subscribeKlaviyo();
    }

    attributeChangedCallback(name, oldValue, newValue) {
      switch (name) {
        case 'email':
          this.email = newValue;
          break;
        case 'message':
          this.elMessage.innerHTML = newValue;
          break;
      }
    }
  }

  customElements.define('newsletter-form', NewsletterForm);
}
